// @ts-check
const { mapIdentifier, mapProperties, mapVariant } = require('../mappers');

/**
 * @param {import('../').EquinoxNormalProduct} product
 * @param {string} market
 * @returns {import('../').EquinoxNormalProduct}
 */
function productNotFound(product, market) {
  /** @type {import('../').EquinoxNormalProduct} */
  const model = {};
  model.identifier = mapIdentifier(` ${product.identifier}`);
  model.properties = mapProperties();
  model.exists = mapExists(product.exists);
  model.sku = [mapVariant({
    // adding a whitespace allows us to display an SKU with 55
    // without initializing the variant selector of ns-product-small
    identifier: ` ${product.identifier}`,
    properties: {
      availableChannels: 'subscription,arsPhone,kiosk,mobile,web',
      customerTypes: 'BrandAffiliate,Preferred,Retail',
      description: 'not-found',
      // uploaded in bynder
      imageURL: 'https://media.nuskin.com/m/6d7d31f64cd9e7c2/JPG_Version-product-not-available.jpg',
      isExclusive: 'false',
      market,
      name: ` ${product.identifier}`,
      productStatus: 'stopped',
      scanQualifiedCount: '0',
      status: 'active',
      title: ` ${product.identifier}`
    }
  })];

  return model;
}

/**
 * @param {boolean|undefined} exists 
 */
function mapExists(exists) {
  if (exists === undefined) {
    return true;
  }

  return exists;
}

module.exports = productNotFound;
